import React from 'react';
import './index.css';

function Explanation({content}) {
    return (
        <div className='digitalExplanation'>
            <p className='digitalExplanation__text'>
                <span className='katex'>
                    {content}
                </span>
            </p>
        </div>
    );
}

export default Explanation;